import { PaperTypeItem } from '@/templates/models/paper-type-item.model';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({})
export default class EdPaperTypeItem extends Vue {

  @Prop() readonly paper: PaperTypeItem;

  public imgLoaded: boolean = false; 

  get cover(): any {
    return { backgroundImage: `url(${this.paper.imageUrl})`};
  }

  get selected(): boolean {
    return this.paper.selected;
  }

  get name() {
    return this.paper.name;
  }

  mounted() {
    let img = new Image();
    img.onload = () => {
      this.imgLoaded = true;
    };
    img.onerror = (err) => {}
    img.src = this.paper.imageUrl;
  }

}